import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep px-4 py-10 text-center text-white" data-id="element-116" data-mp="32wmqdx7xtgw2">
      <p className="font-display text-xl font-black" data-id="element-117" data-mp="3gg118925080a">🧶 KARITO EDUCA</p>
      <p className="mt-1 text-sm text-white/70" data-id="element-118" data-mp="32oe281gt8ldt">Sistema ¿Qué Tejo Hoy?™</p>
      <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-white/70" data-id="element-119" data-mp="36pfs3rou7l34">
        <a href="#" className="hover:text-white" data-id="element-120" data-mp="3ufa4k858v7mu">Términos y Condiciones</a>
        <span className="text-white/30" data-id="element-121" data-mp="3ucxsgbm63rhp">·</span>
        <a href="#" className="hover:text-white" data-id="element-122" data-mp="38z6mkvj6mzq">Política de Privacidad</a>
        <span className="text-white/30" data-id="element-123" data-mp="3lem0a55nkln5">·</span>
        <a href="#" className="hover:text-white" data-id="element-124" data-mp="3ldu4ouc22nwv">Política de Reembolso</a>
        <span className="text-white/30" data-id="element-125" data-mp="3qcnh0jflw8vg">·</span>
        <a href="#" className="hover:text-white" data-id="element-126" data-mp="3qfjhaeexf9n2">Contacto</a>
      </nav>
      <p className="mt-5 text-xs text-white/50" data-id="element-127" data-mp="29xlymixf0ugg">
        © 2026 Karito Educa. Todos los derechos reservados.
      </p>
    </footer>;
}